import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesPaths
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModulePathsSelected = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url = module.paths?.length
    ? `/admin/paths?page=1&sortBy=queryIds` +
      `&limit=${module.paths.length}` +
      `&id=${module.paths.join(filterValuesSeparator)}`
    : '';

  return (
    <div>
      <HomePageSettingsTilesPaths
        includeActions={true}
        module={module}
        updateModule={updateModule}
        url={url}
      />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.commonSelectedPaths,
            value: module.paths?.length || 0
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          hideLimit={true}
          module={module}
          onUpdate={updateModule}
          productType="path"
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModulePathsSelected;
